import React from "react";

function CallToActionFooter() {
  return (
    <section className="bg-customcolor text-white py-12 relative overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-between relative z-10">
          
          {/* Left Text */}
          <h2 className="text-3xl md:text-4xl font-bold mb-6 md:mb-0 max-w-xl leading-snug">
            Are you looking for top experts <br /> and technology?
          </h2>

          {/* Right Button */}
          <button className="border border-white text-white font-semibold px-8 py-3 hover:bg-white hover:text-customcolor transition rounded-none">
            JOIN US
          </button>
        </div>

        {/* Left Dotted Background */}
        <div className="absolute left-0 top-1/2 transform -translate-y-1/2">
          <div className="grid grid-cols-6 gap-2 opacity-40 ml-6">
            {Array.from({ length: 36 }).map((_, i) => (
              <div key={i} className="w-1 h-1 bg-white rounded-full" />
            ))}
          </div>
        </div>

        {/* Right Dotted Background */}
        <div className="absolute right-0 top-1/2 transform -translate-y-1/2">
          <div className="grid grid-cols-6 gap-2 opacity-40 mr-6">
            {Array.from({ length: 36 }).map((_, i) => (
              <div key={i} className="w-1 h-1 bg-white rounded-full" />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default CallToActionFooter;
